import type { Region } from '@/modules/region/domain/Region';
import type { HttpRegionDto } from '@/modules/region/infrastructure/dto/HttpRegionDto';

export const httpRegionDtoToRegionResponse = (
  regions: HttpRegionDto
): Region[] => {
  return regions.payload.map((region) => ({
    id: Number(region?.id),
    name: region?.name,
    communes: region?.comunas?.map((commune) => ({
      code: commune?.id,
      name: commune?.nombre,
      id: Number(commune?.id)
    }))
  }));
};
